module.exports = __webpack_public_path__ + "img/militarnyi.13a6624d.svg";